/* eslint-disable import/no-cycle */
import axiosInstance from '../axiosInstance';

export const devicesApi = {
    post: async (path, params, cancelToken) =>
        axiosInstance
            .post(`/CloudMessaging${path}`, params, {
                cancelToken: cancelToken?.token
            })
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                console.log('err', err);
                throw err.error ? err : err?.response;
            }),
    get: async (path, params, cancelToken) =>
        axiosInstance
            .get(
                `/CloudMessaging${path}`,
                { params },
                {
                    cancelToken: cancelToken?.token
                }
            )
            .then((res) => {
                if (res?.data?.error) throw res.data;
                return res?.data;
            })
            .catch((err) => {
                throw err.error ? err : err?.response;
            })
};

export const getRegisteredDevices = async () => devicesApi.get('/GetRegisteredDevices'); // dont use it

export const registerDevice = async (params) => devicesApi.post('/PairDevice', params);

export const issueActivationToken = async (params) => devicesApi.get('/IssueActivationToken', params);

export const requestAction = async (params) => devicesApi.post('/RequestAction', params);

export const unpairDevice = async (params) => devicesApi.post('/UnpairDevice', params);

export const unpairDeviceFromSession = async (params) => devicesApi.post('/UnpairDeviceFromSession', params);

export const isSessionPaired = async (params) => devicesApi.get('/IsSessionPaired', params);
